import React, { useState } from 'react';
import { TimelineListItemTitleText } from '../shared/TimelineListItemTitleText';
import { TimelineListItemDateText } from '../shared/TimelineListItemDateText';
import dayjs from 'dayjs';
import { TimelineListItemInfoChip } from '../shared/TimelineListItemInfoChip';
import '@fontsource/lato';
import { FaTimes } from 'react-icons/fa';
import ReactModal from 'react-modal';
import { PDFViewer } from '../../PDFViewer';
import clsx from 'clsx';
import { Button } from '@mui/material';
import { ContentCopy, OpenInNew } from '@mui/icons-material';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';
ReactModal.setAppElement('[data-app]');
const onCopy = () => {
    toast.success('Text has been copied to clipboard.');
};
export const ActivityTimelineListItem = (props) => {
    const { timelineActivity } = props;
    const [reportVisible, setReportVisible] = useState(false);
    const handleReportClick = () => {
        setReportVisible(true);
    };
    const onRequestClose = () => setReportVisible(false);
    return (React.createElement("div", { className: 'rounded bg-white pl-4 pt-4 pr-4 pb-4 space-y-2 block justify-start m-4' },
        React.createElement(TimelineListItemTitleText, { titleText: timelineActivity.activityTitle }),
        React.createElement(TimelineListItemDateText, { nameText: timelineActivity.userName, dateText: dayjs(timelineActivity.date).format('MM/DD/YYYY HH:mm A') }),
        React.createElement("div", null,
            timelineActivity.program &&
                React.createElement(TimelineListItemInfoChip, { label: 'Program', value: timelineActivity.program ?? '', backgroundColor: '#F5F5F5', textColor: '#757575', 
                    // backgroundColor={timelineActivity.program === 'RPM' ? '#EAF2FD' : '#018FB71A'}
                    // textColor={timelineActivity.program === 'RPM' ? '#4387ED' : '#018FB7'}
                    showPhoneIcon: false, crossOut: false }),
            React.createElement(TimelineListItemInfoChip, { label: 'Time Entered', value: timelineActivity.reviewTimeSpent ?? '', backgroundColor: '#F5F5F5', textColor: '#757575', showPhoneIcon: timelineActivity.reviewDidTalk ?? false, crossOut: false })),
        React.createElement("textarea", { style: {
                fontFamily: 'Lato, sans-serif',
                fontWeight: '400',
                fontSize: '16px',
                color: '#00000061',
                padding: '5px',
                width: '100%',
                border: '1px solid #0000003B',
                borderRadius: '4px',
                height: '65px',
                overflowY: 'scroll',
                scrollbarWidth: 'thin',
                scrollbarColor: '#888 transparent'
            }, value: timelineActivity.notes ?? '', readOnly: true }),
        React.createElement("div", { className: 'block' },
            React.createElement(CopyToClipboard, { text: timelineActivity.notes, onCopy: onCopy },
                React.createElement(Button, { style: {
                        borderRadius: '16px',
                        backgroundColor: '#018FB7',
                        color: '#F5F5F5',
                        height: '25px',
                        fontWeight: '700',
                        fontSize: 'small'
                    } },
                    React.createElement(ContentCopy, { style: { fontSize: 'small', marginRight: '5px' } }),
                    " Copy")),
            React.createElement(Button, { onClick: handleReportClick, style: {
                    marginLeft: '10px',
                    borderRadius: '16px',
                    backgroundColor: '#018FB7',
                    color: '#F5F5F5',
                    height: '25px',
                    fontWeight: '700',
                    fontSize: 'small'
                } },
                React.createElement(OpenInNew, { style: { fontSize: 'small', marginRight: '5px' } }),
                " View Report")),
        React.createElement(ReactModal, { isOpen: reportVisible, onRequestClose: onRequestClose, contentLabel: 'Patient report', overlayClassName: "bg-black bg-opacity-90 inset-0 fixed z-40", className: clsx('fixed z-50 inset-0 grid place-items-center overflow-auto max-h-screen p-4 focus:outline-none') },
            React.createElement(PDFViewer, { file: timelineActivity.reportId ?? 'empty' }),
            React.createElement("button", { type: "button", "aria-label": "Close report", onClick: onRequestClose, className: "fixed z-50 top-0 right-0 w-10 h-10 flex items-center justify-center" },
                React.createElement("div", { className: "flex items-center w-6 h-6 justify-center rounded-full bg-black border-2 border-white" },
                    React.createElement(FaTimes, { className: "w-3 h-3 text-white" }))))));
};
